export default "__VITE_PUBLIC_ASSET__49a37d0b__"